<template>
  <div
    :class="[`nice-select ${className}`, { open }] "
    tabindex="0"
    @click.prevent="toggleOpen"
    role="button"
  >
    <span class="current">{{ displayText }}</span>
    <ul class="list" role="menubar" @click.prevent="$event.stopPropagation()">
      <li
        :class="[`option`, { 'selected focus': isSelected(item) }]"
        v-for="(item, index) in options"
        :key="`option-${index}`"
        @click.prevent="currentHandler(item, index)"
        role="menuitem"
      >
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NiceSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultCurrent: {
      type: Number,
      required: true,
    },
    /** When set (e.g. from route `web_category=id`), selects matching option key. */
    modelValue: {
      type: [String, Number, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
    className: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  emits: ["onChange", "update:modelValue"],
  data() {
    return {
      open: false,
      current: null,
    };
  },
  computed: {
    displayText() {
      if (!this.options.length) return this.placeholder;
      if (this.current && this.current.text != null) return this.current.text;
      return this.placeholder;
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.applySelection();
      },
    },
    modelValue: {
      immediate: true,
      handler() {
        this.applySelection();
      },
    },
  },
  methods: {
    isSelected(item) {
      const c = this.current;
      if (!c || item == null) return false;
      return String(item.value) === String(c.value);
    },
    applySelection() {
      const opts = this.options || [];
      if (!opts.length) {
        this.current = {};
        return;
      }
      const want = this.modelValue;
      if (want !== null && want !== undefined && want !== '') {
        const found = opts.find((o) => String(o.value) === String(want));
        if (found) {
          this.current = found;
          return;
        }
      }
      const idx = Number(this.defaultCurrent) || 0;
      const safe = Math.min(Math.max(0, idx), opts.length - 1);
      this.current = opts[safe] || opts[0] || {};
    },
    toggleOpen() {
      this.open = !this.open;
    },
    onClose() {
      this.open = false;
    },
    currentHandler(item, index) {
      this.current = this.options[index] ?? item;
      this.$emit("update:modelValue", this.current?.value ?? null);
      this.$emit("onChange", item);
      this.onClose();
    },
  },
};
</script>

<style scoped>
/* Add styles here if needed */
</style>
